import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    seconds: number;
    size?: number;
    color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'progress';
    widthPercentage?: number;
    onTimeout: () => void;
}

export const CircularCountdown = (props: Props) => {
    const [secondsLeft, setSecondsLeft] = React.useState(props.seconds);
    const [progress, setProgress] = React.useState(100);

    React.useEffect(() => {
        const timer = setInterval(() => {
            if (secondsLeft <= 0) {
                clearInterval(timer);
                props.onTimeout();
                return;
            }
            const currentSecLeft = secondsLeft - 0.5;
            setSecondsLeft(currentSecLeft);
            setProgress((currentSecLeft / props.seconds) * 100);
        }, 500);
        return () => {
            clearInterval(timer);
        };
    }, [props, secondsLeft]);

    function getLineColor(progress: number): 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
        if (props.color === 'progress') {
            if (progress > 75) {
                return 'success';
            }
            if (progress > 50) {
                return 'info';
            }
            if (progress > 25) {
                return 'warning';
            }
            return 'error';
        }
        return props.color ?? 'info';
    }

    return (
        <CircularProgress variant="determinate" value={progress} color={getLineColor(progress)} size={props.size ?? 100}  />
    );
};
